import React, { createContext, useContext, useState } from 'react';
import {
  ILanguageProviderProps,
  ILocale,
  DefaultLanguage,
  LanguageObject,
  LANGUAGES,
} from './types';
import { getCookie } from 'commonUtils/src/getCookie';

const initialState: ILocale = {
  locale: DefaultLanguage,
  setLocale: () => {},
};

const LanguageContext = createContext<ILocale>(initialState);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

const getLanguageByLocaleCode = (
  value?: string | null
): LanguageObject | undefined => {
  if (!value) {
    return undefined;
  }

  const locale = value.toLowerCase();
  if (locale === 'es-us' || locale === 'es') {
    return LANGUAGES.es;
  }

  if (locale === 'en-us' || locale === 'en') {
    return LANGUAGES.en;
  }

  return undefined;
};

const LanguageProvider = ({ children }: ILanguageProviderProps) => {
  const psLocale = getCookie('PS_Locale');
  const urlLocale =
    typeof window === 'undefined'
      ? undefined
      : new URLSearchParams(window.location.search).get('locale');
  const initialLanguage =
    getLanguageByLocaleCode(urlLocale) ??
    getLanguageByLocaleCode(psLocale) ??
    DefaultLanguage;

  const [locale, setLocale] = useState<LanguageObject>(initialLanguage);

  return (
    <LanguageContext.Provider value={{ locale, setLocale }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
